import {Link} from "react-router-dom";
import CallMeComponent from "../../components/callMe/CallMeComponent.tsx";
import ContactPageLayout from "./ContactPageLayout.tsx";
import Routing from "../../Routing.ts";

export default function ContactOrderPage() {
    return (
        <ContactPageLayout
            meta_title={"Få hjælp til at bestille internet"}
            meta_description={"Få hjælp af en af vores imødekommende rådgivere til at bestille den bedste internetløsning til dig og dit hjem."}
            title={"Jeg vil gerne bestille bredbånd"}
            className={"page-contact-order"}
            content={
                <>
                    <section className="contact-content contact-order">
                        <CallMeComponent />
                    </section>

                    <div className="contact-sub contact-order">
                        <h2 className="heading heading--montserrat heading--medium">Er du eksisterende kunde?</h2>
                        <p>Så kan du få hjælp herunder:</p>
                        <div className="contact-menu">
                            <div>
                                <h3 className="heading heading--montserrat heading--small">Internet</h3>
                                <ul>
                                    <li><Link to={Routing.Contact.InternetNotWorking}>Mit internet virker slet ikke</Link></li>
                                    <li><Link to={Routing.Contact.InternetUnstable}>Ustabilt internet</Link></li>
                                    <li><Link to={Routing.Contact.RouterSetup}>Opsætning af router</Link></li>
                                </ul>
                            </div>
                            <div>
                                <h3 className="heading heading--montserrat heading--small">Abonnement</h3>
                                <ul>
                                    <li><Link to={Routing.Contact.EquipmentReturn}>Returnering af udstyr</Link></li>
                                    <li><Link to={Routing.Contact.BillAndPaymentCard}>Regning og betalings&shy;kort</Link></li>
                                    <li><Link to={Routing.Contact.Subscription}>Abonnement</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </>
            }
        />
    )
}
